import React, { FC, Fragment, useContext, useEffect, useMemo, useRef, useState } from "react";

import CommentListing from "./CommentListing";

import SectionDateRange from "./SectionDateRange";
//import StayDatesRangeInput from "./StayDatesRangeInput";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
//import { Amenities_demos, PHOTOS } from "./constant";
import { Dialog, Transition, Popover } from "@headlessui/react";
import { ArrowRightIcon, ArrowSmallLeftIcon, ChatBubbleLeftRightIcon, Squares2X2Icon } from "@heroicons/react/24/outline";
import ButtonSecondary from "shared/Button/ButtonSecondary";
import ButtonClose from "shared/ButtonClose/ButtonClose";
import ButtonCircle from "shared/Button/ButtonCircle";
import Input from "shared/Input/Input";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import DetailPagetLayout from "./Layout";
//import GuestsInput from "./GuestsInput";
import NcInputNumber from "./NcInputNumber";

import { requestAPI } from "utils/api";

import { UIContext } from "contexts/UIContext";
import { GlobalDataContext } from "contexts/GlobalData";
import MobileFooterSticky from "./MobileFooterSticky";
//import { Gallery } from "react-grid-gallery";
//import Lightbox from "react-image-lightbox";
//import "react-image-lightbox/style.css";
//import { images, CustomImage } from "./images";

import { RowsPhotoAlbum } from "react-photo-album";
import "react-photo-album/rows.css";

import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";

// import optional lightbox plugins
import Fullscreen from "yet-another-react-lightbox/plugins/fullscreen";
import Slideshow from "yet-another-react-lightbox/plugins/slideshow";
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import "yet-another-react-lightbox/plugins/thumbnails.css";

import { fieldValidator } from 'utils/fieldValidation';
import SigninForm from "components_custom/SigninForm/SigninForm";
import CommunityBadge from "components_custom/CommunityBadge/CommunityBadge";
import ViewTitle from "./ViewTitle";

import ViewContents from "./ViewContents";
import ViewContents2 from "./ViewContents2";
import ViewContents3 from "./ViewContents3";
import CommentList from "./CommentList";
import ChatList from "./ChatList";
import FAQ from "./FAQ";
import FloattingButtons from "components_custom/FloattingButtons/FloattingButtons";


//const breakpoints = [1080, 640, 384, 256, 128, 96, 64, 48];

const StayDetailPageContainer = ({
	id,
	info,
	setInfo,
	communityBoardList,
	isReserve
}: any) => {

	const {
		toast,
		modal,
	} = useContext(UIContext);  
	const { 
		initData
	} = useContext (GlobalDataContext);

	let [isOpenModalAmenities, setIsOpenModalAmenities] = useState(false);
	let [bodyStyle, setBodyStyle] = useState((info.bodyStyle === undefined || info.bodyStyle === null)? "RadioBodyStyle" : info.bodyStyle);
	let [editorShow, setEditorShow] = useState(false);

	const [index, setIndex] = useState(-1);
	
	const [editorHtmlString, setEditorHtmlString] = useState("");
	//const [commentContents, setCommentContents] = useState("");
	//const [chatContents, setChatContents] = useState("");
	const [guestAdultsInputValue, setGuestAdultsInputValue] = useState(1);
	const [orderAmount, setOrderAmount] = useState(info.price * guestAdultsInputValue);

	const thisPathname = useLocation().pathname;
	const router = useNavigate();
	const photos: any = [];

	//const chatbox = useRef <any> (null);

	console.log("><><<>> ", info.travelAgency_no);
	

	info.galleryImgs.map((item: any) => {
		
		photos.push({
			src: `${process.env.REACT_APP_SERVER_FILE}/products/${id}/${item.src}`,
			width: item.width,
			height: item.height,
		})
	});

	
	// ![]()
	let description = info.description.replace(
		/\!\[([^\][]*)]\(([^()]*)\)/g,
  		'<img width="100%" src="$2" alt="$1" target="_blank" />'
	);
	
	// @[]()
	description = description.replace(
		/\@\[([^\][]*)]\(([^()]*)\)/g,
		`<iframe width="100%" height="400px" src='https://www.youtube.com/embed?autoplay=1&mute=1&version=3&loop=1&listType=playlist&list=$2' />`
	);

	//console.log("??????", info)

	

	function closeModalAmenities() {
		setIsOpenModalAmenities(false);
	}

	function openModalAmenities() {
		setIsOpenModalAmenities(true);
	}

	function includeChangeText(item: string) {
		switch(item) {
			case "Hotel": return {text: "숙박제공", icon: "la-hotel"}; break;
			case "Breakfast": return {text: "조식제공", icon: "la-pizza-slice"}; break;
			case "Bike": return {text: "바이크제공", icon: "la-motorcycle"}; break;
			case "NationalPark": return {text: "국립공원입장료", icon: "la-ticket-alt"}; break;
			default: return {text: "N/A", icon: "la-question"}; break;
		}
  	}

	const handleOpenModalImageGallery = () => {
		router(`${thisPathname}/?modal=PHOTO_TOUR_SCROLLABLE`);
	};

	const handleSaveRequest = async () => {

		const res_info: any = await requestAPI ('PUT', `v1/product/${id}/description`, {
			description: editorHtmlString
		});

		//setInfo(res_info.data.info);
		navigate(0);
	};

	const fieldEmptyCheck = (text : string) => {
		//공백이 있으면 true
		
		const regex = /^\s*$/;

		// console.log(text === '');
		// console.log(text === null);
		// console.log(text === undefined);
		// console.log();

		if (text === '' || text === null || text === undefined || regex.test(text)) {
		  return "HasEmpty";     
		}
		
		return 'NoEmpty';
	};

	const handleChangeData = (value: number, type: any) => {
		let newValue = {
		  guestAdults: guestAdultsInputValue,
		//   guestChildren: guestChildrenInputValue,
		//   guestInfants: guestInfantsInputValue,
		};
		
		if (type === "guestAdults") {
		  setGuestAdultsInputValue(value);
		  newValue.guestAdults = value;
		  setOrderAmount(info.price * value);
		}
		// if (type === "guestChildren") {
		//   setGuestChildrenInputValue(value);
		//   newValue.guestChildren = value;
		// }
		// if (type === "guestInfants") {
		//   setGuestInfantsInputValue(value);
		//   newValue.guestInfants = value;
		// }
	};

	/* 포함사항 */
	const renderSection3 = () => {
		return (
		<div className="listingSection__wrap space-y-0 p-0">
			<div className="pl-5 pt-5">
				<h2 className="text-2xl font-semibold">포함사항</h2>
				<span className="block mt-2 text-neutral-500 dark:text-neutral-400">
					{` 여행중 별도 비용이 필요 없는 항목`}
				</span>
			</div>
			<div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>
			<div className="pt-5" />

			{/* 6 */}
			<div className="grid grid-cols-1 xl:grid-cols-3 gap-6 text-sm text-neutral-700 dark:text-neutral-300 bg-white pt-5 pb-5 pl-5 pr-5 rounded-b-2xl">
				{
					Object.keys(info).length === 0
					? 
						""
					:
						info.include.filter((_: any, i: number) => i < 12).map((item: any) => {
							
							const _item = includeChangeText(item);
							return (
								<div key={_item.text} className="flex items-center space-x-3">
									<i className={`text-3xl las ${_item.icon}`}></i>
									<span className="">{_item.text}</span>
								</div>
							)
						})
					
				}
			</div>
			{/* <div className="w-14 border-b border-neutral-200"></div> */}
			
			{
				Object.keys(info).length > 0 && info.include.length > 12
				?
					<div>	
						<ButtonSecondary onClick={openModalAmenities}>
							View more 20 amenities
						</ButtonSecondary>
						{renderMotalAmenities()}
					</div>
				:
					""
			}
		</div>
		);
	};

	const renderMotalAmenities = () => {
		return (
		<Transition appear show={isOpenModalAmenities} as={Fragment}>
			<Dialog
			as="div"
			className="fixed inset-0 z-50 overflow-y-auto"
			onClose={closeModalAmenities}
			>
			<div className="min-h-screen px-4 text-center">
				<Transition.Child
				as={Fragment}
				enter="ease-out duration-300"
				enterFrom="opacity-0"
				enterTo="opacity-100"
				leave="ease-in duration-200"
				leaveFrom="opacity-100"
				leaveTo="opacity-0"
				>
				<Dialog.Overlay className="fixed inset-0 bg-black bg-opacity-40" />
				</Transition.Child>

				{/* This element is to trick the browser into centering the modal contents. */}
				<span
				className="inline-block h-screen align-middle"
				aria-hidden="true"
				>
				&#8203;
				</span>
				<Transition.Child
				as={Fragment}
				enter="ease-out duration-300"
				enterFrom="opacity-0 scale-95"
				enterTo="opacity-100 scale-100"
				leave="ease-in duration-200"
				leaveFrom="opacity-100 scale-100"
				leaveTo="opacity-0 scale-95"
				>
				<div className="inline-block py-8 h-screen w-full max-w-4xl">
					<div className="inline-flex pb-2 flex-col w-full text-left align-middle transition-all transform overflow-hidden rounded-2xl bg-white dark:bg-neutral-900 dark:border dark:border-neutral-700 dark:text-neutral-100 shadow-xl h-full">
					<div className="relative flex-shrink-0 px-6 py-4 border-b border-neutral-200 dark:border-neutral-800 text-center">
						<h3
						className="text-lg font-medium leading-6 text-gray-900"
						id="headlessui-dialog-title-70"
						>
						Amenities
						</h3>
						<span className="absolute left-3 top-3">
						<ButtonClose onClick={closeModalAmenities} />
						</span>
					</div>
					<div className="px-8 overflow-auto text-neutral-700 dark:text-neutral-300 divide-y divide-neutral-200">
						{/* {Amenities_demos.filter((_, i) => i < 1212).map((item) => (
						<div
							key={item.name}
							className="flex items-center py-2.5 sm:py-4 lg:py-5 space-x-5 lg:space-x-8"
						>
							<i
							className={`text-4xl text-neutral-6000 las ${item.icon}`}
							></i>
							<span>{item.name}</span>
						</div>
						))} */}
					</div>
					</div>
				</div>
				</Transition.Child>
			</div>
			</Dialog>
		</Transition>
		);
	};
	
	/* 후기 */
	const renderCommunity = () => {
		
		console.log('Render Community~~~~~~~', communityBoardList);

		return (
			<div id="community" className="listingSection__wrap space-y-0 p-0">
				{/* HEADING */}
				<div className="pl-5 pt-5">
					<h2 className="text-lg sm:text-2xl font-semibold">후기</h2>
					<div className="pt-3 w-14 border-b border-neutral-200 dark:border-neutral-700"></div>
				</div>
				<div className="pt-5" />
				<div className="bg-white p-3 rounded-2xl">

					{
						(communityBoardList.length > 0)
						?
							communityBoardList.map((item: any, idx: number) => (
								<div 
									key={`communityboardlist_${idx}`}
									className="mt-2 mb-4 pb-4 border-b border-neutral-200 line-clamp-6"
								>
									<Link
										to={`/community/${item._id}`}
										className="flex items-center"
									>
										<CommunityBadge type={item.type} />
										<div
											className="ml-2"
										>
											{item.title}
										</div>
									</Link>
								</div>
							))
						:
							<div className="text-center">커뮤니티 게시글이 없어요</div>
					}
					
				{/* <div className="pt-8">
					<ButtonSecondary>View more 20 reviews</ButtonSecondary>
				</div> */}
				</div>
			</div>
		);
	};

	/* 여행 일정 */
	const renderTravelSchedules = (list: any) => {
		return (
			<>
				<div id="travelSchedules" className="listingSection__wrap space-y-0 p-0">
					
					<div className="pl-5 pt-5">
						<h2 className="text-lg sm:text-2xl font-semibold">여행 일정</h2>
						<div className="pt-3 w-14 border-b border-neutral-200 dark:border-neutral-700"></div>
					</div>
					
					<div className="pt-5" />

					<div className={`flex justify-center bg-white pt-5 pb-5 rounded-2xl ql-font-${info.travelSchedulesFont}`}>
						<ul role="list" className="space-y-6 font-semibold">
						{
								list.map((item: any, idx: number) => {
									
									let _class = "";
									
									if ((list.length-1) === idx) {
										_class = "absolute left-[89px] sm:left-[109px] top-0 flex w-6 justify-center";
									} else {
										_class = "-bottom-6 absolute left-[89px] sm:left-[109px] top-0 flex w-6 justify-center";
									}

									return (
										<li key={`schedules_${idx}`} className={`relative flex gap-x-4`} style={{fontSize: info.travelSchedulesFontSize}}>
											<div className="min-w-[60px] sm:min-w-[80px] text-left font-medium">
												{item.day}
											</div>
											
											<div className={_class}>
												<div className="w-px bg-gray-200" />
											</div>
											
											<div className="min-w-[50px] sm:min-w-[50px] relative flex h-6 w-6 flex-none items-center justify-center">
												<div className="h-5 w-5 rounded-full bg-gray-100 ring-1 ring-gray-300" />	
											</div>

											<div className="">
												{item.title}
											</div>
										</li>
									);
								})
							}
						</ul>
					</div>
					{/* <SectionDateRange 
						_startDate={info.reservationStart}
						_endDate={info.reservationEnd}
					/> */}
				</div>
			</>
		);
	};
  
  	const navigate = useNavigate ();

  	const handleBack = () => {
		navigate('/home');
	};

	const handleMovingTagPosition = (id: string) => {
		const element = document.getElementById(id);

		let height = 0;

		switch(id) {
			case "information": height = 90; break;
			case "travelSchedules": height = 90; break;
			case "chatting": height = 70; break;
			case "community": height = 90; break;
			case "comments": height = 90; break;
		}

		if (element) {
			// 요소의 위치를 확인
			const elementPosition = element.getBoundingClientRect().top + window.scrollY;

			// 50픽셀을 뺀 위치로 스크롤
			window.scrollTo({
				top: elementPosition - height, // 50픽셀을 뺀 위치로 이동
				behavior: 'smooth' // 부드럽게 스크롤
			});
		} else {
			console.error("Element not found");
		}
	};


  return (
    <div className="nc-ListingStayDetailPage mb-[10rem]">
      
	  	{/*  HEADER */}
		<div className="relative container ListingDetailPage__content !p-0">
			{info.cover === null
			?
				<>자료가 없을때</>
			:
				info.cover.type==="image"
					?
					<>
						<img	
							src={`${process.env.REACT_APP_SERVER_FILE}/products/${id}/${info.cover.src}`}
						/>
					</>
					:
					<>
						<video 
							className="relative"
							loop 
							muted
							autoPlay
							controls={false}  // 컨트롤 숨김
							playsInline  // Safari에서 인라인 재생을 강제
							disablePictureInPicture  // PiP 모드 비활성화
							webkit-playsinline="true"  // iOS Safari 지원
							x-webkit-airplay="deny"
							preload="auto"
							src={`${process.env.REACT_APP_SERVER_FILE}/products/${id}/${info.cover.src}`}
						/>
					</>
			
			}

			{/*에이전시 로고 노출*/}
			{info.travelAgency_logo && (
				<div className="absolute top-5 right-5 z-10 flex items-center bg-black/60 rounded-lg pl-3 pr-3 pt-2 pb-2 space-x-3">
					<img 
						src={`${process.env.REACT_APP_SERVER_FILE}/${info.travelAgency_logo}`}
						className="w-[2.5rem] h-[2.5rem] object-contain rounded"
						alt={info.travelAgency_name}
					/>
					{/* {info.travelAgency_name && (
						<span className="ml-1 text-2xl font-semibold text-white">{info.travelAgency_name}</span>
					)} */}
				</div>
			)}
			
			{info.bodyStyle !== "RadioBodyStyle2"
			?
				<div className="hidden absolute inset-0 bg-black bg-opacity-60 flex flex-col">
					
					<div className="flex justify-start items-start p-4">
						<div className="w-full text-[2.5rem] text-left text-white text-opacity-40 font-black tracking-tight mt-3 ml-3">ALLTA</div>
					</div>

					
					<div className="flex-grow flex justify-center items-center">
						<span className="text-white"></span>
						<div className="p-8 w-full text-4xl text-center text-white text-opacity-30 font-black">{info.title}</div>
					</div>

					
					<div className="flex justify-end items-end">
						<div className="border-2 border-white/50 p-2 rounded-xl pt-6 pr-3 pb-6 pl-3 mr-4 mb-4">
							<div className="w-full text-2xl text-center text-indigo-300 text-opacity-30">ALLTA</div>
							<div className="w-full text-2xl text-center text-indigo-300 text-opacity-30">LICENSE</div>
						</div>
					</div>
				</div>
			:
				<></>
			}
		</div>

		{/* 메뉴 */}
		<div className="sticky inset-0 bg-white z-40 flex items-center justify-between">
			<div className="container flex items-center justify-between sm:w-[768px] !p-0">
				<div className="w-full ">
					
					<div className="border-b border-gray-200">
						<nav aria-label="Tabs" className="flex font-bold text-[0.85rem]">
							<a
								onClick={() => handleMovingTagPosition("information")}
								className="border-transparent text-gray-600 hover:border-indigo-500 w-1/4 border-b-2 px-1 py-4 text-center"	
							>
								PROGRAM
							</a>
							{/* <a
								onClick={() => handleMovingTagPosition("travelSchedules")}
								className="border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700 w-1/5 border-b-2 px-1 py-4 text-center"	
							>
								schedule
							</a> */}
							<a
								onClick={() => handleMovingTagPosition("community")}
								className="border-transparent text-gray-500 hover:border-indigo-500 hover:text-gray-700 w-1/4 border-b-2 px-1 py-4 text-center"	
							>
								COMMUNITY
							</a>
							<a
								onClick={() => handleMovingTagPosition("chatting")}
								className="border-transparent text-gray-500 hover:border-indigo-500 hover:text-gray-700 w-1/4 border-b-2 px-1 py-4 text-center"	
							>
								REVIEW
							</a>
							<a
								onClick={() => handleMovingTagPosition("comments")}
								className="border-transparent text-gray-500 hover:border-indigo-500 hover:text-gray-700 w-1/4 border-b-2 px-1 py-4 text-center"	
							>
								Q & A
							</a>
						</nav>
					</div>
					
					
				</div>
			</div>
        </div>

		{/* MAIN */}
		<main className={(info.bodyStyle === "RadioBodyStyle2")
			? "relative z-10 mt-0 ml-0 mr-0 sm:mt-3 sm:ml-2 sm:mr-2" 
			: "relative z-10 mt-3 ml-3 mr-3 sm:mt-3 sm:ml-2 sm:mr-2"
		}>
			{/* CONTENT */}
			<div className="w-full space-y-8">
				
				{(bodyStyle === "RadioBodyStyle") && (
					<>
					<ViewTitle 
						info={info}
					/>

					<ViewContents
						title={"투어 소개"}
						description={info.description}
					/>

					<ViewContents
						title={"포함 사항"}
						description={info.inclusions}
					/>

					<ViewContents
						title={"불포함 사항"}
						description={info.exclusions}
					/>

					<ViewContents
						title={"선택옵션"}
						description={info.pickedOption}
					/>

					<ViewContents
						title={"오버뷰"}
						description={info.overview}
					/>
							
					{renderTravelSchedules(info.travelSchedules)}

					<ViewContents
						title={"루트"}
						description={info.route}
					/>

					<ViewContents
						title={"렌트 바이크 정보 & 자동차 정보"}
						description={info.bikeInfo}
					/>

				</>)}
				{(bodyStyle === "RadioBodyStyle1") && (
					<ViewContents2
						description={info.description}
					/>
				)}

				{(bodyStyle === "RadioBodyStyle2") && (
					<ViewContents3
						description={info.description}
					/>
				)}
				

				{info.tail !== null && (
					<div className="relative container ListingDetailPage__content !p-0">
						{process.env.REACT_APP_SERVER_FILE && (
							<video 
								className="relative !w-full"
								loop 
								muted
								autoPlay
								controls={false}  // 컨트롤 숨김
								playsInline  // Safari에서 인라인 재생을 강제
								disablePictureInPicture  // PiP 모드 비활성화
								webkit-playsinline="true"  // iOS Safari 지원
								x-webkit-airplay="deny"
								preload="auto"
								src={`${process.env.REACT_APP_SERVER_FILE}/products/${id}/bottom.mp4`}
								onError={(e) => {
									const target = e.target as HTMLVideoElement;
									target.style.display = 'none';
								}}
							/>
						)}
					</div>
				)}

				<RowsPhotoAlbum photos={photos} targetRowHeight={150} onClick={({ index }) => setIndex(index)} />

				<Lightbox
					slides={photos}
					open={index >= 0}
					index={index}
					close={() => setIndex(-1)}
					// enable optional lightbox plugins
					plugins={[Fullscreen, Slideshow, Thumbnails, Zoom]}
				/>
				

				{/* {renderSection5()} */}
				{/* {renderSection7()} */}
				{/* {renderSection8()} */}

				<ChatList 
					isReserve={isReserve}
					no={info.no}
				/>

				{renderCommunity()}

				<CommentList 
					no={info.no}
					info={info}
					agencyNo={info.travelAgency_no}
				/>

				{(bodyStyle === "RadioBodyStyle") && (
					<>
					<ViewContents
						title={"중요사항"}
						description={info.importantNotes}
					/>

					<ViewContents
						title={"환불규정"}
						description={info.refundPolicy}
					/>
					</>
				)}

				<FAQ productType={info.type} />
				
			</div>

			{/* SIDEBAR */}
			{/* <div className="hidden lg:block flex-grow mt-14 lg:mt-0">
			<div className="sticky top-28">{renderSidebar()}</div>
			</div> */}
		</main>
    </div>
  );
};

export default function DetailMotorCycleTours() {

	const { id } = useParams();
	
	const navigate = useNavigate ();

	const [info, setInfo] = useState <{}> ({});
	const [communityBoardList, setCommunityBoardList] = useState <[]> ([]);
	
	const [isReserve, setIsReserve] = useState <any> (null);
	

	//const [title, setTitle] = useState <string> ("");

	useEffect (() => {
		(async () => {
			
			const res: any = await requestAPI('GET', `v1/product/${id}`, null);
			const res2: any = await requestAPI('GET', `v1/reserve/product/${id}/me`, null);
			const res3: any = await requestAPI('GET', `v1/community/product/${id}`, null);

			console.log("!!! >> ", res2);

			setInfo(res.data.info)
			setIsReserve(res2.data.info);
			setCommunityBoardList(res3.data.list);
		})();

		const metaTag = document.querySelector('meta[name="viewport"]');
		if (metaTag) {
		  metaTag.setAttribute("content", "width=device-width, initial-scale=1.0");
		}
	
		// 페이지를 떠날 때 원래대로 복구
		return () => {
		  if (metaTag) {
			metaTag.setAttribute(
			  "content",
			  "width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
			);
		  }
		};
	}, [])

	if (Object.keys(info).length === 0) {
		return (<></>)
	}

	const handleBack = () => {
		navigate('/home');
	}

  return (
	<>
		<div className="sticky inset-0 bg-white z-40 flex items-center justify-between">
			<div className="container flex items-center justify-between sm:w-[768px] !p-0 h-[62px]">
				<div className="flex items-center">
					<button
						className="focus:outline-none focus:ring-0 w-10 h-10 rounded-full flex items-center justify-center hover:bg-neutral-100 ml-2"
						onClick={()=> handleBack()}
					>
						<ArrowSmallLeftIcon className="w-6 h-6" />
					</button>
					<span className="text-xl">
						뒤로
					</span>
				</div>
			</div>
        </div>

		<div className="container flex items-center justify-between lg:w-[768px] !p-0">
			<DetailPagetLayout id={id}>
				
				<StayDetailPageContainer 
					id={id} 
					info={info} 
					setInfo={setInfo}
					communityBoardList={communityBoardList}
					isReserve={isReserve}
				/>
				
				{/* STICKY FOOTER MOBILE */}
				<MobileFooterSticky 
					id={id} 
					info={info}
					
				/>
				<FloattingButtons bottom={false}/>
			</DetailPagetLayout>
		</div>
	</>
    
  );
}
